import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'waiting-button',
})
class WaitingButton extends Vue {
    @Prop({ default: false })
    disabled!: boolean;

    @Prop({ default: false })
    loading!: boolean;

    /**
     * - primary
     * - secondary
     * - text
     * - link
     * - ghost
     * - outline
     * - option
     * - wIcon
     * - tertiary
     */
    @Prop({ default: 'primary' })
    type!: string;

    @Prop({ default: 'botton' })
    htmlType!: string;

    @Emit('click')
    onClick(e: any) {
        return e;
    }
}

export default WaitingButton;



// WEBPACK FOOTER //
// ./src/components/waiting-button/waiting-button.ts